import { isApiName } from 'self-service-api/core/type-guards/apiName';
import { useProductsWithSkuCategoryNameInInventory } from '../inventory/useProductInventoryLookup';

/**
 * @description
 * Returns the owned hubspot credits total, sku, and api name.
 * Replaces getOwnedHubSpotCreditsTotal, getOwnedHubSpotCreditsSku, and getOwnedHubSpotCreditsApiName.
 *
 * @returns {
 *  ownedHubSpotCreditsTotal: number,
 *  ownedHubSpotCreditsSkuId: number,
 *  ownedHubspotCreditsApiName: ApiName | undefined,
 *  loading: boolean,
 *  error: ApolloError | undefined,
 * }
 */
export const useHubSpotCreditsInventoryInfo = () => {
  const {
    productsWithSkuCategoryName,
    loading,
    error
  } = useProductsWithSkuCategoryNameInInventory({
    skuCategoryName: 'HUBSPOT_CREDITS'
  });
  const ownedHubSpotCreditsProduct = productsWithSkuCategoryName === null || productsWithSkuCategoryName === void 0 ? void 0 : productsWithSkuCategoryName.find(product => product.skuQuantityPurchased > 0);
  const ownedHubSpotCreditsTotal = (ownedHubSpotCreditsProduct === null || ownedHubSpotCreditsProduct === void 0 ? void 0 : ownedHubSpotCreditsProduct.skuQuantityPurchased) || 0;
  const ownedHubSpotCreditsSkuId = ownedHubSpotCreditsProduct === null || ownedHubSpotCreditsProduct === void 0 ? void 0 : ownedHubSpotCreditsProduct.skuId;
  const ownedHubSpotCreditsApiNameString = ownedHubSpotCreditsProduct === null || ownedHubSpotCreditsProduct === void 0 ? void 0 : ownedHubSpotCreditsProduct.productApiName;
  const ownedHubspotCreditsApiName = ownedHubSpotCreditsApiNameString && isApiName(ownedHubSpotCreditsApiNameString) ? ownedHubSpotCreditsApiNameString : undefined;
  return {
    ownedHubSpotCreditsTotal,
    ownedHubSpotCreditsSkuId,
    ownedHubspotCreditsApiName,
    loading,
    error
  };
};